// src/components/Reports/utils/htmlUtils.js

/**
 * Strips HTML wrapper tags and sanitizes content
 */
export const stripHtmlWrapper = (html) => {
    return html
        .replace(/<html[^>]*>/gi, '')
        .replace(/<\/html>/gi, '')
        .replace(/<head[^>]*>[\s\S]*?<\/head>/gi, '')
        .replace(/<body[^>]*>/gi, '')
        .replace(/<\/body>/gi, '');
};

/**
 * Removes potentially dangerous script tags
 */
export const sanitizeScripts = (html) => {
    return html
        .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '')
        .replace(/on\w+\s*=\s*["'][^"']*["']/gi, '')
        .replace(/javascript:/gi, '');
};

/**
 * Clean and prepare HTML content for safe use
 */
export const prepareHtmlContent = (html) => {
    let cleaned = stripHtmlWrapper(html);
    cleaned = sanitizeScripts(cleaned);
    return cleaned;
};

/**
 * Wait for fonts to be loaded
 */
export const waitForFonts = async () => {
    try {
        if (document.fonts && document.fonts.ready) {
            await document.fonts.ready;
            console.log('✅ Fonts loaded');
        } else {
            // Fallback for browsers that don't support document.fonts.ready
            await new Promise(resolve => setTimeout(resolve, 1000));
            console.log('✅ Fallback font wait completed');
        }
    } catch (error) {
        console.warn('⚠️ Font loading wait failed:', error);
        await new Promise(resolve => setTimeout(resolve, 1000));
    }
};
